import React from 'react'
import styled from 'styled-components'
import { rgba } from 'polished'
import Layout from '../components/layout'
import GridBg from '../components/grid'
import { th, Box, Typography } from '@smooth-ui/core-sc'
import { imgLogo } from '../images'
import { At, Buoy, Envelope, Phone } from 'styled-icons/boxicons-regular'

const ContactItem = styled.div`
  border: 1px solid ${th('gray300')};
  border-top: 5px solid ${th('gray300')};
  border-radius: ${th('borderRadius')};
  padding: 1rem;
  display: inline-flex;
  flex-direction: column;
  margin-right: 0.5rem;
  width: 300px;
  text-align: left;
  transition: box-shadow 0.25s, border-color 0.25s;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    box-shadow: 0 0 0 0.35rem ${th('primary', color => rgba(color, 0.2))};
    border-top-color: ${th('primary')};
  }

  & h4 {
    color: ${th('primary')};
    margin: 0;
    padding: 0;
  }

  & h4 svg {
    margin-right: 0.5rem;
    position: relative;
    top: -1px;
  }

  & p {
    color: ${th('gray600')};
    font-size: 0.875rem;
  }

  & p > strong {
    border-bottom: 1px solid ${th('primary')};
    color: ${th('primary')};
  }

  & a {
    color: ${th('primary')};
    font-size: 0.875rem;
    text-decoration: none;
  }

  & a > span {
    border-bottom: 1px solid ${th('primary')};
  }
`

const IndexPage = () => (
  <Layout>
    <GridBg>
      <Box>
        <Box textAlign="center" maxWidth={650} mx="auto" pt="5rem">
          <Box mb="3rem">
            <img
              src={imgLogo}
              alt="Muhsis Yardım ve Destek Merkezi"
              height="60"
            />
          </Box>
          <Typography variant="h4" mt={3}>
            Yardım & Destek Merkezi
          </Typography>
          <Box>
            Muhsis'te tüm ekip olarak, müşterilerimizin memnuniyetine çok önem
            veriyoruz. Tüm soru, öneri ve şikayetlerinizi, istediğiniz zaman,
            uygulama içerisinden veya telefonla arayarak bizimle
            paylaşabilirsiniz. Destek ekibimiz, size severek yardımcı olacaktır.
          </Box>

          <Box textAlign="center" mt={4}>
            <ContactItem>
              <h4>
                <Buoy size={20} />
                Yardım & Destek Merkezi
              </h4>
              <p>
                Şu anda yardım merkezimiz ile ilgili çalışmalarımızı
                sürdürüyoruz. Kullanım videoları, genel muhasebe ile ilgili
                bilgiler, makalelere buradan ulaşabileceksiniz.
              </p>
            </ContactItem>
            <ContactItem>
              <h4>
                <Envelope size={20} />
                Bize Ulaşın
              </h4>

              <p>
                Ekibimize{' '}
                <strong>
                  destek
                  <At size="14" />
                  muhsis.com
                </strong>{' '}
                adresine e-posta göndererek, ya da{' '}
                <strong>
                  <Phone size="14" /> 0850 532 6949
                </strong>{' '}
                numaralı destek hattımızı arayarak ulaşabilirsiniz.
              </p>
            </ContactItem>
          </Box>
        </Box>

        <Box textAlign="center" mt="2rem" color="gray500" fontSize={1}>
          &copy; 2018 - Muhsis
        </Box>
      </Box>
    </GridBg>
  </Layout>
)

export default IndexPage
